import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const partnergiftCardApi = createAsyncThunk("partnergiftCard", async () => {
  const response = await axiosInstance.get(`/gift/get/all/allocation`);
  return response.data;
});

const partnergiftCardSlice = createSlice({
  name: "partnergiftCard",
  initialState: {
    partnergiftCard: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(partnergiftCardApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(partnergiftCardApi.fulfilled, (state, action) => {
        state.partnergiftCard = action.payload;
        state.loading = false;
      })
      .addCase(partnergiftCardApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default partnergiftCardSlice.reducer;
